import { Input, Button } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useState } from "react";
import { usePaginationPrzekazy } from "../../../context/PaginationContextPrzekazy";

const SearchInput = ({ placeholder = "Search...", onSearch }) => {
	const { pagination, setPagination } = usePaginationPrzekazy();
	const [value, setValue] = useState(
		JSON.parse(localStorage.getItem("searchPrzekazy")),
	);

	const handleChange = (e) => {
		setValue(e.target.value);
	};

	const submitSearch = () => {
		setPagination({ ...pagination, search: value, current: 1 });
	};

	const handleSearch = () => {
		if (onSearch) onSearch(value);
		setPagination({ ...pagination, search: value, current: 1 });
	};

	const handleClear = () => {
		setValue("");
		setPagination({ ...pagination, search: "", current: 1 });
		if (onSearch) onSearch("");
	};

	return (
		<div
			style={{ display: "flex", width: "100%" }}
			className="search-wrapper"
		>
			<Input
				value={value}
				defaultValue={value}
				onChange={handleChange}
				width="100%"
				disabled={pagination.loading}
				onPressEnter={submitSearch}
				addonBefore={<SearchOutlined onClick={handleChange} />}
				placeholder="Wyszukaj przekaz"
				style={{
					borderRadius: "0px !important",
					maxWidth: "400px",
				}}
			/>
			<Button
				onClick={handleSearch}
				disabled={pagination.loading}
				style={{
					height: "100%",
					borderLeft: "none",
					borderRadius: "0",
				}}
			>
				Wyszukaj
			</Button>
			<Button
				onClick={handleClear}
				disabled={pagination.loading}
				style={{
					height: "100%",
					borderLeft: "none",
					borderRadius: "0 2px 2px 0",
				}}
			>
				Wyczyść
			</Button>
		</div>
	);
};

export default SearchInput;
